import React from 'react';
import css from './css/CurrentEnvironmentDisplay.module.css'

const CurrentEnvironmentDisplay = () => {

    const env = process.env.REACT_APP_CURRENT_ENV;
    if(env !== 'development' && env !== 'staging')
    {
        return null;
    }

    const envDisplay = env === 'development' ? 'Development' : 'Staging';

    return (
        <div className={css.wrapper}>
            {envDisplay}
        </div>
    );
};

export default CurrentEnvironmentDisplay;